export default __webpack_public_path__ + "static/media/Boby.73eebd52.jpg";